import { Reveal } from "@/components/Reveal";
import { StayCard } from "@/components/StayCard";
import { PROPERTIES } from "@/data/properties";
import site from "@/data/content/site.json";

const copy = site.stays;

export const Stays = () => {
  return (
    <section
      id="stays"
      data-testid="stays-section"
      className="scroll-mt-24 bg-[#F7F2EA]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="max-w-2xl">
          <Reveal>
            <span className="text-xs tracking-[0.25em] uppercase text-terracotta font-medium">
              {copy.eyebrow}
            </span>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 font-serif text-4xl md:text-5xl font-semibold text-brown">
              {copy.heading}
            </h2>
          </Reveal>
        </div>

        {/* Mobile: free horizontal swipe with momentum (card peeks) · Desktop: grid */}
        <div className="mt-8 flex gap-4 sm:gap-6 overflow-x-auto no-scrollbar overscroll-x-contain [-webkit-overflow-scrolling:touch] pb-4 -mx-4 px-4 sm:mx-0 sm:px-0 sm:grid sm:grid-cols-2 lg:grid-cols-4 sm:overflow-visible">
          {PROPERTIES.map((property, i) => (
            <StayCard key={property.slug} property={property} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stays;
